(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["abuelo-academy-course"] && !Shopify.designMode) return;
  try {
    
function aeInitCourse(){document.querySelectorAll('[data-ae-course]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const key='ae-academy-v1-'+root.dataset.aeUser;let state={steps:{},notes:{}};try{const data=JSON.parse(localStorage.getItem(key)||'null');if(data&&typeof data.steps==='object'&&typeof data.notes==='object')state=data;}catch(e){}const inputs=[...root.querySelectorAll('[data-ae-step]')];const refresh=()=>{const count=inputs.filter(x=>x.checked).length;root.querySelector('[data-ae-progress]').value=count;root.querySelector('[data-ae-progress-label]').textContent=count+' / 7';inputs.forEach(x=>x.closest('details').dataset.completed=String(x.checked));};const save=()=>{try{localStorage.setItem(key,JSON.stringify(state));}catch(e){root.querySelector('[data-ae-storage-status]').textContent=root.dataset.storageError;}};inputs.forEach(x=>{x.checked=state.steps[x.dataset.aeStep]===true;x.addEventListener('change',()=>{state.steps[x.dataset.aeStep]=x.checked;save();refresh();});});root.querySelectorAll('[data-ae-notes]').forEach(x=>{const value=state.notes[x.dataset.aeNotes];x.value=typeof value==='string'?value.slice(0,4000):'';x.addEventListener('input',()=>{state.notes[x.dataset.aeNotes]=x.value;save();});});root.querySelectorAll('a[href^="#ae-paso-"]').forEach(a=>a.addEventListener('click',()=>{const d=document.getElementById(a.hash.slice(1));if(d)d.open=true;}));const copy=root.querySelector('[data-ae-copy]');copy?.addEventListener('click',async()=>{const prompt=root.querySelector('[data-ae-prompt]'),status=root.querySelector('[data-ae-copy-status]');try{await navigator.clipboard.writeText(prompt.value);status.textContent=root.dataset.copied;}catch(e){prompt.focus();prompt.select();status.textContent=root.dataset.copyError;}});refresh();});}aeInitCourse();document.addEventListener('shopify:section:load',aeInitCourse);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ae-academy-journey"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAcademyJourney(){
    var root=document.getElementById('aeJourney');
    if(!root||root.dataset.ready)return;
    root.dataset.ready='true';
    var total=8;
    var customerKey=root.dataset.customerKey||'preview';
    var storageKey='abueloAcademyJourneyV4:'+customerKey;
    var state={version:4,step:1,completed:[],tasks:{},settings:{models:[]},renderUrl:'',prompt:'',updatedAt:''};
    try{
      var saved=JSON.parse(window.localStorage.getItem(storageKey)||'null');
      if(saved&&saved.version===4)state=Object.assign(state,saved);
    }catch(error){}
    if(!state.settings||typeof state.settings!=='object')state.settings={models:[]};
    if(!Array.isArray(state.settings.models))state.settings.models=[];
    if(!Array.isArray(state.completed))state.completed=[];
    if(!state.tasks||typeof state.tasks!=='object')state.tasks={};
    state.step=Math.max(1,Math.min(total,Number(state.step)||1));

    var steps=[].slice.call(root.querySelectorAll('.aej-step'));
    var progressStep=root.querySelector('#aejProgressStep');
    var progressFill=root.querySelector('#aejProgressFill');
    var progressBar=root.querySelector('.aej-progress__track');
    var percent=root.querySelector('#aejPercent');
    var savedLabel=root.querySelector('#aejSaved');
    var back=root.querySelector('#aejBack');
    var toast=root.querySelector('#aejToast');
    var renderUrl=root.querySelector('#aejRenderUrl');
    var renderUrlError=root.querySelector('#aejRenderUrlError');
    var voiceSpeed=root.querySelector('#aejVoiceSpeed');
    var voiceSpeedValue=root.querySelector('#aejVoiceSpeedValue');
    var voiceSample=root.querySelector('#aejVoiceSample');
    var voiceFileName=root.querySelector('#aejVoiceFileName');
    var prompt=root.querySelector('#aejFirstPrompt');
    var generateAction=root.querySelector('#aejGenerateAction');
    var openedStatus=root.querySelector('#aejStudioOpened');
    var saveFlashTimer;
    var toastTimer;

    function persist(){
      state.updatedAt=new Date().toISOString();
      try{
        window.localStorage.setItem(storageKey,JSON.stringify(state));
        savedLabel.classList.add('is-visible');
        window.clearTimeout(saveFlashTimer);
        saveFlashTimer=window.setTimeout(function(){savedLabel.classList.remove('is-visible')},1100);
      }catch(error){}
      window.dispatchEvent(new CustomEvent('ae:academy-progress',{detail:{customerKey:customerKey,state:state}}));
      if(window.AEAcademyProgressAdapter&&typeof window.AEAcademyProgressAdapter.save==='function'){
        Promise.resolve(window.AEAcademyProgressAdapter.save(customerKey,state)).catch(function(){});
      }
    }

    function showToast(message){
      toast.textContent=message;
      toast.classList.add('is-visible');
      window.clearTimeout(toastTimer);
      toastTimer=window.setTimeout(function(){toast.classList.remove('is-visible')},1500);
    }

    function markTask(name,value){
      state.tasks[name]=value!==false;
      persist();
      draw();
    }

    function isValidUrl(value){
      try{
        var url=new URL(value);
        return url.protocol==='https:'||url.protocol==='http:';
      }catch(error){
        return false;
      }
    }

    function requirementsMet(button){
      var requirements=(button.dataset.requires||'').split(' ').filter(Boolean);
      if(requirements.some(function(name){return !state.tasks[name]}))return false;
      var settingRequirements=(button.dataset.requiresSetting||'').split(' ').filter(Boolean);
      if(settingRequirements.some(function(name){return !state.settings[name]}))return false;
      if(button.hasAttribute('data-requires-model')&&!state.settings.models.length)return false;
      return true;
    }

    function voiceLabel(){
      var selected=root.querySelector('[data-choice-group="voiceStyle"] [data-value="'+(state.settings.voiceStyle||'')+'"]');
      return selected?selected.textContent.trim():'—';
    }

    function updateSummary(){
      root.querySelector('#aejSelectedModel').textContent=state.settings.models[0]||'—';
      root.querySelector('#aejGenerationFormat').textContent=state.settings.format||'—';
      root.querySelector('#aejGenerationQuality').textContent=state.settings.quality||'—';
      root.querySelector('#aejGenerationDuration').textContent=state.settings.duration||'—';
      root.querySelector('#aejSummaryVoice').textContent=voiceLabel();
      root.querySelector('#aejSummaryModels').textContent=state.settings.models.join(' · ')||'—';
      root.querySelector('#aejSummaryFormat').textContent=[state.settings.format,state.settings.quality,state.settings.duration].filter(Boolean).join(' · ')||'—';
    }

    function draw(){
      steps.forEach(function(step){step.hidden=Number(step.dataset.step)!==state.step});
      progressStep.textContent=String(state.step);
      var progress=state.step===8?100:Math.round(state.completed.length/total*100);
      progressFill.style.width=progress+'%';
      percent.textContent=String(progress);
      progressBar.setAttribute('aria-valuenow',String(progress));
      back.hidden=state.step===1||state.step===8;

      root.querySelectorAll('[data-task]').forEach(function(button){
        var done=!!state.tasks[button.dataset.task];
        button.classList.toggle('is-done',done);
        button.setAttribute('aria-pressed',String(done));
        var pending=button.querySelector('[data-pending]');
        var completed=button.querySelector('[data-done]');
        var copyLabel=button.querySelector('[data-copy-label]');
        var copyDone=button.querySelector('[data-copy-done]');
        if(pending)pending.hidden=done;
        if(completed)completed.hidden=!done;
        if(copyLabel)copyLabel.hidden=done;
        if(copyDone)copyDone.hidden=!done;
      });

      root.querySelectorAll('[data-choice-group]').forEach(function(group){
        var name=group.dataset.choiceGroup;
        group.querySelectorAll('[data-value]').forEach(function(button){
          button.classList.toggle('is-selected',state.settings[name]===button.dataset.value);
          button.setAttribute('aria-pressed',String(state.settings[name]===button.dataset.value));
        });
      });
      root.querySelectorAll('[data-model]').forEach(function(button){
        var selected=state.settings.models.indexOf(button.dataset.model)>-1;
        button.classList.toggle('is-selected',selected);
        button.setAttribute('aria-pressed',String(selected));
      });
      root.querySelectorAll('[data-next]').forEach(function(button){button.disabled=!requirementsMet(button)});

      renderUrl.value=state.renderUrl||'';
      voiceSpeed.value=String(state.settings.voiceSpeed||100);
      voiceSpeedValue.textContent=String(state.settings.voiceSpeed||100);
      prompt.value=state.prompt||'';
      var canGenerate=isValidUrl(state.renderUrl)&&state.prompt.trim().length>=12&&state.settings.models.length>0;
      generateAction.disabled=!canGenerate;
      var opened=!!state.tasks.studio_opened;
      generateAction.querySelector('[data-open-label]').hidden=opened;
      generateAction.querySelector('[data-finish-label]').hidden=!opened;
      openedStatus.hidden=!opened;
      updateSummary();
      persist();
    }

    function moveTo(nextStep){
      var update=function(){
        state.step=nextStep;
        draw();
        window.scrollTo({top:0,behavior:'smooth'});
      };
      if(document.startViewTransition)document.startViewTransition(update);
      else update();
    }

    root.addEventListener('aej:task-complete',function(event){
      if(event.detail&&event.detail.task)markTask(event.detail.task,true);
    });

    root.querySelectorAll('.aej-task[data-task]').forEach(function(button){
      button.addEventListener('click',function(){
        if(button.dataset.url){
          window.open(button.dataset.url,'_blank','noopener');
          markTask(button.dataset.task,true);
          return;
        }
        markTask(button.dataset.task,!state.tasks[button.dataset.task]);
      });
    });

    root.querySelectorAll('.aej-command[data-copy-value]').forEach(function(button){
      button.addEventListener('click',function(){
        var value=button.dataset.copyValue;
        var fallback=function(){
          var area=document.createElement('textarea');
          area.value=value;
          area.setAttribute('readonly','');
          area.style.position='fixed';
          area.style.opacity='0';
          document.body.appendChild(area);
          area.select();
          document.execCommand('copy');
          area.remove();
        };
        var copyPromise=navigator.clipboard&&navigator.clipboard.writeText?navigator.clipboard.writeText(value):Promise.resolve().then(fallback);
        Promise.resolve(copyPromise).then(function(){
          markTask(button.dataset.task,true);
          showToast(root.dataset.copied);
        }).catch(function(){
          fallback();
          markTask(button.dataset.task,true);
          showToast(root.dataset.copyError);
        });
      });
    });

    renderUrl.addEventListener('input',function(){
      state.renderUrl=renderUrl.value.trim();
      state.tasks.render_url=isValidUrl(state.renderUrl);
      renderUrlError.hidden=!state.renderUrl||state.tasks.render_url;
      persist();
      draw();
    });
    renderUrl.addEventListener('blur',function(){
      renderUrlError.hidden=!renderUrl.value||isValidUrl(renderUrl.value.trim());
    });

    root.querySelectorAll('[data-choice-group]').forEach(function(group){
      group.querySelectorAll('[data-value]').forEach(function(button){
        button.addEventListener('click',function(){
          state.settings[group.dataset.choiceGroup]=button.dataset.value;
          persist();
          draw();
        });
      });
    });

    root.querySelectorAll('[data-model]').forEach(function(button){
      button.addEventListener('click',function(){
        var model=button.dataset.model;
        var index=state.settings.models.indexOf(model);
        if(index>-1)state.settings.models.splice(index,1);
        else state.settings.models.push(model);
        persist();
        draw();
      });
    });

    voiceSpeed.addEventListener('input',function(){
      state.settings.voiceSpeed=Number(voiceSpeed.value);
      voiceSpeedValue.textContent=voiceSpeed.value;
      persist();
    });
    voiceSample.addEventListener('change',function(){
      var file=voiceSample.files&&voiceSample.files[0];
      if(file){
        state.settings.voiceFileName=file.name;
        voiceFileName.textContent=file.name;
        persist();
      }
    });

    prompt.addEventListener('input',function(){
      state.prompt=prompt.value;
      persist();
      generateAction.disabled=!(isValidUrl(state.renderUrl)&&state.prompt.trim().length>=12&&state.settings.models.length>0);
    });

    root.querySelectorAll('[data-next]').forEach(function(button){
      button.addEventListener('click',function(){
        if(!requirementsMet(button))return;
        var current=Number(button.dataset.next);
        if(state.completed.indexOf(current)===-1)state.completed.push(current);
        if(current===5)state.settings.voiceSpeed=Number(voiceSpeed.value);
        persist();
        moveTo(current+1);
      });
    });

    generateAction.addEventListener('click',function(){
      if(generateAction.disabled)return;
      if(!state.tasks.studio_opened){
        if(navigator.clipboard&&navigator.clipboard.writeText){
          navigator.clipboard.writeText(state.prompt).catch(function(){});
        }
        window.open(state.renderUrl,'_blank','noopener');
        state.tasks.studio_opened=true;
        persist();
        draw();
        return;
      }
      if(state.completed.indexOf(7)===-1)state.completed.push(7);
      if(state.completed.indexOf(8)===-1)state.completed.push(8);
      persist();
      moveTo(8);
    });

    back.addEventListener('click',function(){
      if(state.step>1&&state.step<8)moveTo(state.step-1);
    });

    root.querySelector('#aejLaunchApp').addEventListener('click',function(){
      if(isValidUrl(state.renderUrl))window.open(state.renderUrl,'_blank','noopener');
    });

    root.querySelector('#aejReset').addEventListener('click',function(){
      state={version:4,step:1,completed:[],tasks:{},settings:{models:[]},renderUrl:'',prompt:'',updatedAt:''};
      try{window.localStorage.removeItem(storageKey)}catch(error){}
      voiceFileName.textContent='';
      draw();
    });

    if(window.AEAcademyProgressAdapter&&typeof window.AEAcademyProgressAdapter.load==='function'){
      Promise.resolve(window.AEAcademyProgressAdapter.load(customerKey)).then(function(remoteState){
        if(remoteState&&remoteState.version===4&&remoteState.updatedAt>state.updatedAt){
          state=Object.assign(state,remoteState);
          draw();
        }
      }).catch(function(){});
    }
    draw();
  }
  initAcademyJourney();
  document.addEventListener('shopify:section:load',initAcademyJourney);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
